module.exports = new __parcel__URL__("frames.9d882bf0.png").toString();